import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function HeadIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M11.79 7.1c.053.801.703 1.272.71 1.69.006.376-.698.505-.698.505s-.16.122.01.374c.17.253-.074.428-.074.428.216.296-.094.538-.094.538-.337.357.07 1.332-.972 1.332-.716 0-1.077.04-1.077.04-.033.716.122 1.993.122 1.993-1.212 0-3.391-.21-4.517-.576l.005-.033c.9-4.297-1.43-3.674-1.682-6.637-.237-2.806 1.355-4.534 3.5-4.731 2.694-.249 4.929 1.575 4.929 3.757 0 .736-.166 1.217-.166 1.217s.048-.006.105-.037a.15.15 0 0 1-.06.065c.003-.001.043-.012.063-.028 0 .002-.01.035-.034.043l.04-.009s-.017.04-.11.07" /></svg>
  );
}

export default HeadIcon;
